'use strict';
import NavEvent from './components/NavEvent';

document.addEventListener('DOMContentLoaded', () => {
  const navEvent = new NavEvent();

  if (document.querySelector('.p_topPage')) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        document.querySelector('.p_headerInner').classList.add('Scrolled');
      } else {
        document.querySelector('.p_headerInner').classList.remove('Scrolled');
      }
    });
  }
});
